import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Flex,
  Icon,
  Text,
} from '@kognitos/lattice';

type IUserDetailsProps = {
  name: string;
  subtitle: string;
};

const UserDetails = ({ name, subtitle }: IUserDetailsProps) => {
  return (
    <>
      <Avatar className="h-8 w-8 rounded-lg">
        <AvatarImage alt={name} />
        <AvatarFallback className="rounded-lg bg-sidebar-accent">
          <Icon type="UserRound" size="sm" className="text-foreground" />
        </AvatarFallback>
      </Avatar>
      <Flex
        direction="column"
        align="start"
        className="flex-1 text-left gap-0.5 min-w-0"
      >
        <Text
          level="small"
          className="font-medium leading-none truncate w-full transition-opacity duration-200 group-data-[collapsible=icon]:opacity-0"
        >
          {name}
        </Text>
        <Text
          level="small"
          className="text-muted-foreground leading-none text-xs truncate w-full transition-opacity duration-200 group-data-[collapsible=icon]:opacity-0"
        >
          {subtitle}
        </Text>
      </Flex>
    </>
  );
};

export default UserDetails;
